module.exports = __webpack_public_path__ + "img/logo.a72e0099.png";